var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"guia-pasos"},[_c('img',{attrs:{"alt":"paso_a_paso","src":require("@/assets/img/inicio/Matriculate-2026.png"),"width":"959"}})])
}]

export { render, staticRenderFns }